import { accessUserSchema } from '#src/access/users.contract.js';
import { definePolicy, listQuerySchema } from '#src/rsql/index.js';
const text = {
    type: 'string',
    wildcards: true,
    caseInsensitive: true,
};
/**
 * O que `GET /api/access/users` deixa filtrar, ordenar e pedir.
 * `roles.code` e `roles.name` valem quando algum perfil da pessoa bate.
 */
export const accessUsersPolicy = definePolicy({
    fields: {
        id: { type: 'uuid' },
        name: { ...text, sortable: true },
        email: { ...text, sortable: true },
        active: { type: 'boolean' },
        linkedToEntra: { type: 'boolean' },
        lastSeenAt: { type: 'datetime', sortable: true },
        createdAt: { type: 'datetime', sortable: true },
        'roles.code': { type: 'string' },
        'roles.name': text,
    },
    defaultSort: [{ field: 'name', direction: 'asc' }],
    selectable: accessUserSchema.keyof().options,
});
export const accessUsersQuerySchema = listQuerySchema(accessUsersPolicy);
//# sourceMappingURL=users.policy.js.map